export enum RequestTypeEnum {
  Get = 'Get',
  Post = 'Post',
}



// WEBPACK FOOTER //
// ./src/app/enums/request-type.enum.ts